export const getNursePatients = (patientSchedule, nurseId) =>
	patientSchedule.filter(p => p.assignedNurse === nurseId)

export const getChairPatients = (patientSchedule, chairId) =>
	patientSchedule.filter(p => p.assignedChair === chairId)

export const getNursePatientIds = (patientSchedule, nurseId) =>
	getNursePatients(patientSchedule, nurseId).map(p => p.patientId)

export const getChairPatientIds = (patientSchedule, chairId) =>
	getChairPatients(patientSchedule, chairId).map(p => p.patientId)
